(() => {
  const selector = '.sk-card-swatches li[data-color-name]';

  function selectSwatch(item, event) {
    const card = item.closest('.product-card');
    if (!card) return;

    card.classList.add('sk-swatch-active');

    const picker = item.closest('.sk-card-color-picker');
    const input = item.querySelector('input[type="radio"]');
    const image = card.querySelector('figure picture:first-of-type img:not(.color-variant-img)');
    const colorName = picker && picker.querySelector('.sk-card-color-name');
    const productLinks = card.querySelectorAll('figure > a:first-of-type, h3 a');
    const deliveryLabels = card.querySelectorAll('.sk-card-delivery');

    if (input) input.checked = true;
    if (colorName) colorName.textContent = item.dataset.colorName || '';

    if (image && item.dataset.img) {
      image.src = item.dataset.img;
      image.removeAttribute('srcset');
      if (item.dataset.imgAlt) image.alt = item.dataset.imgAlt;
    }

    if (item.dataset.variantUrl) {
      for (const link of productLinks) link.href = item.dataset.variantUrl;
    }

    if (picker && item.dataset.stockState && deliveryLabels.length) {
      const inStock = item.dataset.stockState === 'in-stock';
      const stockText = inStock ? picker.dataset.stockIn : picker.dataset.stockOut;

      if (stockText) {
        for (const label of deliveryLabels) {
          label.textContent = stockText;
          label.classList.toggle('overlay-valid', inStock);
          label.classList.toggle('overlay-error', !inStock);
          label.setAttribute('aria-live', 'polite');
        }
      }
    }

    if (event && (event.type === 'click' || event.type === 'keydown')) {
      event.preventDefault();
    }
  }

  document.addEventListener('mouseover', (event) => {
    const item = event.target.closest(selector);
    if (item) selectSwatch(item, event);
  });

  document.addEventListener('focusin', (event) => {
    const item = event.target.closest(selector);
    if (item) selectSwatch(item, event);
  });

  document.addEventListener('click', (event) => {
    const item = event.target.closest(selector);
    if (!item) return;
    selectSwatch(item, event);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const item = event.target.closest(selector);
    if (item) selectSwatch(item, event);
  });
})();
